export function getProductPrice(product) {
  return (product.related.buyer_discount !== null ? product.related.buyer_discount.discounted_price : Number(product.item.price)).toFixed(
    2,
  );
}

export function getProductValue(product) {
  return product.item.marketPrice ? product.item.marketPrice : product.item.price;
}

export function hasDiscountedPrice(product) {
  if (product.related.buyer_discount === null) {
    return 'No';
  }
  return product.related.buyer_discount.total_discount > 0 ? 'Yes' : 'No';
}

export function getDiscountAmount(product) {
  return (getProductValue(product) - getProductPrice(product)).toFixed(2);
}

export function getDiscountRange(product) {
  const discountAmount = getDiscountAmount(product);
  const discountRanges = [
    '0.01-10.00',
    '10.01-20.00',
    '20.01-30.00',
    '30.01-40.00',
    '40.01-50.00',
    '50.01-60.00',
    '60.01-70.00',
    '70.01-80.00',
    '80.01-90.00',
    '90.01-100.00',
    '100.01-110.00',
    '110.01-120.00',
    '120.01-130.00',
    '130.01-140.00',
    '140.01-150.00',
  ];

  return discountAmount === '0.00' ? '0.00' : getRange(discountRanges, discountAmount, '150.00+');
}

export function getPriceRange(product) {
  const price = product.item.price;
  const priceRanges = ['0-50', '51-100', '101-150', '151-200', '201-300', '301-499'];

  return getRange(priceRanges, price, '499+');
}

function getRange(rangeArray, value, maxValue) {
  const range = rangeArray.filter(range => {
    const bounds = range.split('-');
    return parseFloat(bounds[0]) <= value && value <= parseFloat(bounds[1]);
  })[0];

  return range ? range : maxValue;
}

export function getBoxType(product) {
  if (product.item.isSev) {
    return 'DEV';
  }
  if (product.item.webExclusive) {
    return 'Web Exclusive';
  }
  if (product.item.isFormatEvoucherBuyer && !product.item.isFormatPhysical && !product.item.isFormatPof) {
    return 'eBox';
  }

  return 'Classic';
}
